import Flash from './flash'
export default Flash



// WEBPACK FOOTER //
// ./src/playbacks/flash/index.js